import { DirectiveOptions } from 'vue';
import { onlyNumber } from '@/utils/dataReplaceUtils'
import _ from 'underscore'

const replaceHandler = event => {
  const value = (event.target as HTMLInputElement).value;
  (event.target as HTMLInputElement).value = onlyNumber(value)
}

/**
 * FIXME: keyCode 는 deprecated 된 값이다. 따라서 플랫폼 이슈가 있을 수 있다.
 * 이를 올바르게 재정의하는 방법은 event: KeyboardEvent 타입에 정의된
 * event.key 나 event.code 를 이용하여 이 기능을 다시 정의하는 것이다.
 */
const keyRejectHandler = event => {
  // Allow: backspace, delete, tab, escape, enter
  if (_.contains([46, 8, 9, 27, 13], event.keyCode) ||
    // Allow: Ctrl + A/X/V/C or Command + A/X/V/C
    (event.ctrlKey === true || event.metaKey) ||
    // Allow: home, end, left, right, down, up
    (event.keyCode >= 35 && event.keyCode <= 40)) {
    // let it happen, don't do anything
    return;
  }

  // Ensure that it is a number and stop the keypress
  if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
    event.preventDefault();
  }
}

const inputOnlyInteger: DirectiveOptions = {
  bind(el: HTMLElement): void {
    el.addEventListener('keyup', replaceHandler)
    el.addEventListener('blur', replaceHandler)
    el.addEventListener('keydown', keyRejectHandler)
  },
  unbind(el: HTMLElement): void {
    el.addEventListener('keyup', replaceHandler)
    el.addEventListener('blur', replaceHandler)
    el.removeEventListener('keydown', keyRejectHandler)
  }
};
export default inputOnlyInteger;
